import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { IntegrationsAPI } from "../../../providers/IntegrationsAPI";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Checkbox } from "../../components/Checkbox";
import { Context } from "pages/Integrations";
import { Toggle } from "shared/components/Toggle";

export default class IFoodDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            loading: false,
            environment: EnvironmentStorage.getEnvironment(),
            active: true,
            merchantId: "",
            preparationTime: undefined,
            cancelationControl: true,
            allowPreview: true,
            allowManualDispatch: false,
        };
    }

    componentDidMount() {
        this.loadAccount();
    }

    async loadAccount() {
        const { environment } = this.state;

        const accountResponse = await IntegrationsAPI.getIFoodAccount(
            environment.id,
        );
        const account = accountResponse.getData({});

        const preparationTime = Number(account?.preparationTime ?? 0) / 60;

        this.setState({
            merchantId: account?.merchantId,
            active: account?.active,
            preparationTime,
            cancelationControl: account?.cancelationControl || false,
            allowPreview: account?.allowPreview || false,
            allowManualDispatch: account?.allowManualDispatch || false,
            loadingPage: false,
        });
    }

    async updateAccount({
        merchantId,
        active,
        preparationTime,
        cancelationControl,
        allowPreview,
        allowManualDispatch,
    }) {
        const { environment } = this.state;

        this.setState({
            loading: true,
        });

        if (preparationTime) {
            preparationTime = Math.trunc(Number(preparationTime)) * 60;
        }

        const data = {
            environmentId: environment.id,
            active,
            merchantId,
            preparationTime,
            cancelationControl,
            allowPreview,
            allowManualDispatch,
        };

        console.log("data");
        console.log(data);

        const updateResponse = await IntegrationsAPI.setIFoodAccount(data);

        if (updateResponse.getErrors([]).length > 0) {
            alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
            this.setState({
                loading: false,
            });
            return false;
        }

        this.setState({
            loading: false,
        });

        return true;
    }

    async changeStep(newStep) {
        this.setState({
            step: newStep,
        });
    }

    render() {
        const {
            loading,
            loadingPage,
            active,
            merchantId,
            preparationTime,
            cancelationControl,
            allowPreview,
            allowManualDispatch,
        } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title="IFood Entrega"
            >
                <Context />

                {loadingPage && (
                    <div className={styles.loading}>
                        <Loading />
                    </div>
                )}
                {!loadingPage && (
                    <div className={styles.scrollContainer}>
                        <div className={styles.toggle}>
                            <div className="d-flex justify-end w-100">
                                <Toggle
                                    active={active}
                                    onChange={(active) =>
                                        this.setState({ active })
                                    }
                                />
                            </div>
                        </div>

                        <Input
                            design="two"
                            label="Merchant Id"
                            className="mb-20"
                            value={merchantId}
                            onChange={(e) =>
                                this.setState({
                                    merchantId: e.target.value.trim(),
                                })
                            }
                        />

                        <Input
                            design="two"
                            label="Tempo de espera para alocar o entregador (Em minutos)"
                            className="mb-20"
                            value={preparationTime}
                            type="number"
                            min="0"
                            step="1"
                            placeholder="Ex: 15 minutos"
                            onChange={(e) =>
                                this.setState({
                                    preparationTime: e.target.value.trim(),
                                })
                            }
                        />

                        <Checkbox
                            name="cancelationControl"
                            design="two"
                            className="mb-10"
                            checked={cancelationControl}
                            onChange={() =>
                                this.setState({
                                    cancelationControl: !cancelationControl,
                                })
                            }
                        >
                            Cancelar pedido quando o operador logístico cancelar
                            ou não conseguir efetuar a entrega?{" "}
                        </Checkbox>

                        <Checkbox
                            name="allowPreview"
                            design="two"
                            className="mb-10"
                            checked={allowPreview}
                            onChange={() =>
                                this.setState({
                                    allowPreview: !allowPreview,
                                })
                            }
                        >
                            Utilizar valor do frete do iFood?{" "}
                        </Checkbox>

                        <Checkbox
                            name="allowManualDispatch"
                            design="two"
                            checked={allowManualDispatch}
                            onChange={() =>
                                this.setState({
                                    allowManualDispatch: !allowManualDispatch,
                                })
                            }
                        >
                            Chamar entregador manualmente?{" "}
                        </Checkbox>

                        <div className={styles.footer}>
                            <Button
                                design="primary"
                                className="w-100"
                                onClick={() =>
                                    this.updateAccount({
                                        merchantId: merchantId,
                                        active: active,
                                        preparationTime: preparationTime,
                                        cancelationControl: cancelationControl,
                                        allowPreview: allowPreview,
                                        allowManualDispatch:
                                            allowManualDispatch,
                                    })
                                }
                                loading={loading}
                                disabled={loading}
                            >
                                Salvar
                            </Button>
                        </div>
                    </div>
                )}
            </Drawer>
        );
    }
}
